import { Link } from "react-router-dom";
import { fileUrl } from "@/lib/api";
import { MapPin, Wrench, Package, Crown } from "lucide-react";

export const ListingCard = ({ listing, index = 0 }) => {
  const img = listing.images?.[0];
  const isService = listing.type === "service";
  return (
    <Link
      to={`/listing/${listing.id}`}
      data-testid={`listing-card-${listing.id}`}
      className="group block bg-white nb-border rounded-2xl overflow-hidden nb-shadow nb-hover"
      style={{ animation: `fadeUp 0.4s ease-out ${index * 0.05}s both` }}
    >
      <div className="relative aspect-[4/3] bg-[#F4F4F5] border-b-2 border-black overflow-hidden">
        {img ? (
          <img src={fileUrl(img)} alt={listing.title} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-black/20">
            {isService ? <Wrench size={48} strokeWidth={2} /> : <Package size={48} strokeWidth={2} />}
          </div>
        )}
        <span className={`absolute top-3 left-3 text-xs font-extrabold nb-border rounded-full px-3 py-1 flex items-center gap-1 ${isService ? "bg-black text-[#E6B31E]" : "bg-[#E6B31E] text-black"}`}>
          {isService ? <Wrench size={12} strokeWidth={3} /> : <Package size={12} strokeWidth={3} />}
          {isService ? "Service" : "Good"}
        </span>
        <span className="absolute top-3 right-3 text-xs font-extrabold nb-border rounded-full px-3 py-1 bg-white text-black">
          ${Number(listing.value_usd).toLocaleString()}
        </span>
        {listing.owner_is_member && (
          <span data-testid="member-listing-badge" className="absolute bottom-3 left-3 flex items-center gap-1 text-[10px] font-extrabold nb-border rounded-full px-2.5 py-1 bg-[#E6B31E] text-black">
            <Crown size={11} strokeWidth={3} /> MEMBER
          </span>
        )}
      </div>
      <div className="p-5">
        <div className="text-[11px] font-bold uppercase tracking-wide text-[#B8860B]">{listing.category}</div>
        <h3 className="font-display font-extrabold text-lg leading-tight mt-1 line-clamp-1">{listing.title}</h3>
        <div className="mt-3 bg-[#FBF7E9] nb-border rounded-lg px-3 py-2">
          <div className="text-[10px] font-bold uppercase text-black/50">Wants in return</div>
          <div className="text-sm font-semibold line-clamp-1">{listing.wanted}</div>
        </div>
        <div className="mt-3 flex items-center justify-between text-xs text-black/50 font-semibold">
          <span className="truncate">by {listing.owner_name}</span>
          {listing.location ? (
            <span className="flex items-center gap-1"><MapPin size={12} strokeWidth={3} /> {listing.location}</span>
          ) : null}
        </div>
      </div>
    </Link>
  );
};
